import Layout from "../../components/Layout";
import {Link, useNavigate} from "react-router-dom";
import SearchBox from "../../components/SearchBox";
import Pagination from "../../components/Pagination";
import StoresTable from "../../components/Tables/StoresTable";
import {useEffect, useState} from "react";
import ApiRoute, {shopId} from "../../helper/api";
import CreateShopModal from "../../components/Shop/CreateShopModal";

function Stores() {

    const navigate = useNavigate()
    const [createModal, setCreateModal] = useState(false)

    const [isLoading, setIsLoading] = useState(true)
    const [updateData, setUpdateData] = useState('0')
    const [pageNumber, setPageNumber] = useState(1)
    const [data, setData] = useState({})
    const [searchQuery, setSearchQuery] = useState({
        term: '',
        by: 'title'
    })
    const [filterQuery, setFilterQuery] = useState({})


    //fetch data from server and update data /| based on updateData state
    useEffect(() => {
        (async () => {
            setIsLoading(true)
            const  res  = await ApiRoute.shop.index.fn({
                page : pageNumber
            },filterQuery)
            setData(res)
            setIsLoading(false)
        })();
    }, [updateData]);

    const paginationData = data?.results
    const tableData = data?.results?.data ?? []

    // watch pageNumber and update updateData state
    useEffect(() => {
        setUpdateData(Date.now().toString())
    }, [pageNumber]);
    // watch searchQuery and update updateData state
    useEffect(() => {
        filterQuery.quick_search = searchQuery
        setUpdateData(Date.now().toString())
    }, [searchQuery]);
    return (
        <Layout>
            <div>
                <div className="flex items-center justify-between mb-3">
                    <div className="page-title flex-auto ml-3 md:ml-0">
                        <span className="inline-block bg-white pl-3">فروشگاه ها</span>
                    </div>
                    <button className="btn-blue text-center md:hidden" onClick={ () => setCreateModal(true) }>افزودن فروشگاه جدید</button>
                </div>

                <div className="grid md:flex w-full justify-between items-center gap-3">
                    <SearchBox SetSearchQuery={setSearchQuery} SearchIn={false}/>
                    <button className="btn-blue text-center hidden md:block" onClick={ () => setCreateModal(true) }>افزودن فروشگاه جدید</button>
                </div>


                <div className="main-content p-1 mt-3">
                    {data && <StoresTable tableData={tableData}/>}
                    {data && <Pagination Data={paginationData} SetPageNumber={setPageNumber}/>}
                </div>
            </div>

            {createModal && <CreateShopModal event={ (res) => {
                setCreateModal(false)
                setUpdateData(Date.now().toString())
            } } closeModal={ () => setCreateModal(false) }/>}

        </Layout>
    )
}

export default Stores